// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Text = function Text(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.714 3.714V5.43a.855.855 0 0 1-.857.857A.855.855 0 0 1 2 5.429v-2C2 2.639 2.64 2 3.429 2H16.57C17.361 2 18 2.64 18 3.429v2a.855.855 0 0 1-.857.857.855.855 0 0 1-.857-.857V3.714h-5.429v12.572h1.714c.475 0 .858.382.858.857a.855.855 0 0 1-.858.857H7.43a.855.855 0 0 1-.858-.857c0-.475.383-.857.858-.857h1.714V3.714z"
  }));
};
